import { TaskStatus } from '../../../domain/types';
import { WithRequiredKeys } from '../../../types';
import { PaginatedResult, PaginationParams, serializePagination } from '../../pagination';
import { API_TASKS_PATH, getClient } from '../api';
import { Task, TaskReference } from '../dtos';
import { CreateProviderFunction, UpdateProviderFunction } from '../types';
import { serializeParams } from '../utils/serializer';

export interface GetTasksFilters {
  status?: TaskStatus | TaskStatus[],
  reference?: Omit<TaskReference, 'user'>
}

export const serializeGetTasksParams = (
  {
    status,
    reference,
  }: GetTasksFilters = {},
  pagination: PaginationParams = {},
) => {
  const filters = {
    status,
    reference: reference ? `${reference.type}:${reference.id}` : undefined,
  };

  return {
    ...serializeParams(filters),
    ...serializePagination(pagination),
  };
};

export const createTask: CreateProviderFunction<Task> = async (task) => {
  const client = await getClient();
  const { data } = await client.post<WithRequiredKeys<Task, 'id'>>(API_TASKS_PATH, task);
  return data;
};

export const updateTask: UpdateProviderFunction<Task> = async (taskId, task) => {
  const client = await getClient();
  const { data } = await client.put<WithRequiredKeys<Task, 'id'>>(`${API_TASKS_PATH}/${taskId}`, task);
  return data;
};

export async function getTask(taskId: NonNullable<Task['id']>): Promise<Task> {
  const client = await getClient();
  const { data } = await client.get<Task>(`${API_TASKS_PATH}/${taskId}`);
  return data;
}

export async function getTasks(
  filters: GetTasksFilters = {},
  pagination: PaginationParams = { size: 50 },
): Promise<PaginatedResult<Task>> {
  const client = await getClient();
  const { data } = await client.get<PaginatedResult<Task>>(API_TASKS_PATH, {
    params: serializeGetTasksParams(filters, pagination),
  });
  return data;
}
